<template>
  <b-modal
    id="customer-receive-detail-modal"
    hide-footer
    :title="
      disabled
        ? `Xem chi tiết khách hàng tiếp nhận`
        : `Cập nhật khách hàng tiếp nhận`
    "
    size="xl"
  >
    <b-container>
      <b-row>
        <b-col cols="3">
          <basic-input
            class="m-0"
            v-model="form.name"
            placeholder="Nhập Họ và tên"
            :disabled="disabled"
            :required="true"
            :value.sync="form.name"
            label="Họ và Tên"
            v-validate="'required'"
            name="fullName"
            data-vv-as="Họ và Tên"
            :state="validateState('fullName')"
            :invalidFeedback="errors.first('fullName')"
          />
        </b-col>
        <b-col cols="2">
          <basic-select
            placeholder="Danh xưng"
            name="title"
            :solid="false"
            changeValueByObject
            label="Danh xưng"
            :disabled="disabled"
            :value="getNameOf('title', this.form.title)"
            :options="titles"
            :clear="false"
            :hideSelected="true"
            trackBy="value"
            valueLabel="text"
            @update:value="selected($event, 'title', titles)"
          />
        </b-col>
        <b-col cols="3">
          <basic-input
            class="m-0"
            v-model="form.phoneNumber"
            placeholder="Nhập số điện thoại"
            :disabled="disabled"
            :required="true"
            label="Số điện thoại"
            name="phoneNumber"
            data-vv-as="Số điện thoại"
            :state="validateState('phoneNumber')"
            :invalidFeedback="errors.first('phoneNumber')"
            type="tel"
            maxlength="13"
            minlength="10"
            pattern="[0-9]{13}"
          />
        </b-col>
        <b-col cols="4">
          <basic-select
            label="Phân loại bệnh"
            placeholder="--- Chọn phân loại ---"
            name="diseaseType"
            :options="diseasesOpts"
            :solid="false"
            :required="true"
            :allowEmpty="false"
            track-by="value"
            value-label="text"
            :disabled="disabled"
            :value="getNameOf('diseaseType', this.form.diseaseType)"
            changeValueByObject
            data-vv-as="Disease"
            v-validate="'required'"
            :state="validateState('diseaseType')"
            :invalidFeedback="errors.first('diseaseType')"
            @update:value="selected($event, 'diseaseType', diseasesOpts)"
          />
        </b-col>
        <b-col cols="4">
          <basic-select
            :required="true"
            placeholder="--- Chọn coach ---"
            name="coach"
            :solid="false"
            changeValueByObject
            label="Coach phụ trách"
            :disabled="disabled"
            :value="getNameOf('coach', this.form.coachId)"
            :options="listCoaches"
            class="filter mb-0"
            :clear="false"
            :hideSelected="true"
            trackBy="value"
            valueLabel="text"
            v-validate="'required'"
            data-vv-as="Coach phụ trách"
            :state="validateState('coach')"
            :invalidFeedback="errors.first('coach')"
            @update:value="selected($event, 'coach', listCoaches)"
          />
        </b-col>
        <b-col cols="4">
          <basic-select
            :required="true"
            placeholder="--- Chọn gói dịch vụ ---"
            name="package"
            :solid="false"
            changeValueByObject
            label="Gói dịch vụ"
            :disabled="disabled"
            :value="getNameOf('package', this.form.packageId)"
            :options="packagesName"
            class="filter mb-0"
            :clear="false"
            :hideSelected="true"
            trackBy="id"
            valueLabel="name"
            v-validate="'required'"
            data-vv-as="Gói dịch vụ"
            :state="validateState('package')"
            :invalidFeedback="errors.first('package')"
            @update:value="selected($event, 'package', packagesName)"
          />
        </b-col>
        <b-col cols="4">
          <basic-select
            placeholder="--- Chọn Partner ---"
            name="partner"
            :solid="false"
            changeValueByObject
            label="Partner"
            :disabled="disabled"
            :value="getNameOf('partner', this.form.customerPartnerId)"
            :options="partners"
            class="filter mb-0"
            :clear="false"
            :hideSelected="true"
            value-label="value"
            data-vv-as="Đối tác"
            :state="validateState('customerPartnerId')"
            :invalidFeedback="errors.first('customerPartnerId')"
            @update:value="selected($event, 'customerPartner', partners)"
          />
        </b-col>
        <b-col cols="4">
          <basic-input
            v-model="form.contactSource"
            placeholder="Nguồn tiếp nhận"
            :disabled="disabled"
            :value.sync="form.contactSource"
            label="Nguồn tiếp nhận"
            name="contactSource"
          />
        </b-col>
        <b-col cols="4">
          <basic-input
            :required="true"
            v-model="form.birthYear"
            placeholder="Năm sinh"
            :disabled="disabled"
            :value.sync="form.birthYear"
            label="Năm sinh"
            name="birthYear"
            v-validate="'required|digits:4'"
            data-vv-as="Năm sinh"
            :state="validateState('birthYear')"
            :invalidFeedback="errors.first('birthYear')"
          />
        </b-col>
        <b-col cols="4">
          <basic-select
            placeholder="--- Chọn giới tính ---"
            name="gender"
            :solid="false"
            changeValueByObject
            label="Giới tính"
            :disabled="disabled"
            :value="getNameOf('gender', this.form.gender)"
            :options="genders"
            :clear="false"
            :hideSelected="true"
            trackBy="value"
            valueLabel="text"
            @update:value="selected($event, 'gender', genders)"
          />
        </b-col>
        <b-col cols="3">
          <basic-input
            v-model="form.yearOfIllness"
            placeholder="Năm bệnh"
            :disabled="disabled"
            label="Năm bệnh"
            name="yearOfIllness"
          />
        </b-col>
        <b-col class="col-3">
          <basic-date-picker
            label="Ngày mua"
            placeholder="Ngày mua"
            name="purchaseDate"
            v-model="form.purchaseDate"
            format="DD-MM-YYYY"
            value-type="date"
            :disabled="disabled"
            data-vv-as="Ngày mua"
            :state="validateState('purchaseDate')"
            :invalidFeedback="errors.first('purchaseDate')"
          />
        </b-col>
        <b-col cols="3">
          <basic-input
            v-model="form.reasonOut"
            placeholder="Ghi chú"
            :disabled="disabled"
            :value.sync="form.reasonOut"
            label="Ghi chú"
            name="reasonOut"
          />
        </b-col>
          <b-col cols="3">
          <basic-select
            label="Nhóm tham gia"
            placeholder="Chọn hoặc nhập nhóm mới"
            name="onboardGroup"
            :disabled="disabled"
            :options="onboardGroupOptions"
            :value.sync="form.onboardGroup"
            track-by="value"
            value-label="text"
            changeValueByObject
            taggable
            tag-placeholder="Thêm mới"
            @tag="addOnboardGroupTag"
          />
        </b-col>
        <b-col cols="12" class="mt-4">
          <b-form-group
            label="Tải lên tệp"
            description="Chọn nhiều tệp để tải lên (PDF, JPG, PNG, DOCX, XLSX)"
          >
            <b-form-file
              v-model="file"
              ref="fileInput"
              :disabled="disabled"
              accept=".pdf, .jpg, .jpeg, .png, .docx, .xlsx"
              placeholder="Chọn tệp..."
              drop-placeholder="Thả tệp vào đây..."
              multiple
              @change="handleFileUpload"
            ></b-form-file>
            <!-- Hiển thị danh sách file vừa chọn -->
            <b-list-group class="mt-2">
              <b-list-group-item
                v-for="(file, index) in selectedFiles"
                :key="'selected-' + index"
                class="d-flex justify-content-between align-items-center"
              >
                <div class="d-flex align-items-center">
                  <span class="svg-icon">
                    <inline-svg :src="getIconPath(file.type)" />
                  </span>
                  <p class="px-2 m-0 d-flex align-items-center">
                    {{ file.title }}
                  </p>
                </div>
                <div>
                  <b-button
                    v-if="['pdf', 'png', 'jpg', 'jpeg'].includes(file.type)"
                    variant="success"
                    size="sm"
                    class="mr-2"
                    @click="previewSelectedFile(file.previewUrl)"
                  >
                    Xem
                  </b-button>
                  <b-button
                    variant="danger"
                    size="sm"
                    @click="removeSelectedFile(index)"
                  >
                    Xóa
                  </b-button>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-form-group>

          <!-- Danh sách các tệp đã tải lên từ server -->
          <b-form-group
            v-if="existingFiles.length > 0"
            label="Danh sách tệp đã tải lên"
            class="mt-3"
          >
            <b-list-group>
              <b-list-group-item
                v-for="(file, index) in existingFiles"
                :key="'existing-' + index"
                class="d-flex justify-content-between align-items-center"
              >
                <div class="d-flex align-items-center">
                  <span class="svg-icon" :class="{ 'icon-disabled': disabled }">
                    <inline-svg :src="getIconPath(file.type)" />
                  </span>
                  <p
                    class="px-2 m-0 d-flex align-items-center"
                    :class="{ 'text-muted': disabled }"
                  >
                    {{ file.title }}{{ file.type }}
                  </p>
                </div>
                <div>
                  <b-button
                    v-if="
                      file.type === '.pdf' ||
                      file.type === '.png' ||
                      file.type === '.jpg'
                    "
                    variant="success"
                    size="sm"
                    class="mr-2"
                    @click="viewFile(file.fileUrl)"
                  >
                    Xem
                  </b-button>
                  <b-button
                    size="sm"
                    class="mr-2 btn-success"
                    @click="downloadFile(file.fileUrl, file.title)"
                  >
                    Tải về
                  </b-button>
                  <b-button
                    v-if="!disabled"
                    variant="danger"
                    size="sm"
                    @click="removeExistingFile(file.id)"
                  >
                    Xóa
                  </b-button>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end align-items-center mt-4">
        <b-button
          class="btn btn-plain ml-2"
          href="#"
          :disabled="loading"
          @click.stop="handleCancel"
          tabindex="0"
        >
          Huỷ
        </b-button>
        <b-button
          v-if="!disabled"
          class="btn btn-success ml-3"
          @click.stop="handleSubmit"
          type="submit"
          :disabled="isDisabled"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
          </span>
          Cập nhật
        </b-button>
        <b-button
          v-if="disabled"
          class="btn btn-success ml-3"
          @click.stop="handelEdit"
          type="submit"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/edit-2.svg" />
          </span>
          Chỉnh sửa
        </b-button>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { DISEASES,ONBOARDING } from '../CustomerReceiveEnum';
const { mapState } = createNamespacedHelpers('customerReceives');

export default {
  name: 'DetailModal',
  props: {
    targetItem: {
      type: Object,
      required: true,
    },
    packagesName: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedFiles: [],
      listCoaches: [],
      listPartners: [],
      loading: false,
      file: [],
      uploadedFiles: [],
      existingFiles: [],
      form: {
        id: null,
        name: '',
        title: null,
        phoneNumber: null,
        gender: null,
        birthYear: null,
        status: null,
        coachId: null,
        reasonOut: null,
        diseaseType: null,
        courseId: null,
        contactSource: null,
        packageId: null,
        yearOfIllness: null,
        purchaseDate: null,
        customerPartnerId: null,
        onboardGroup: null
      },
      img: {
        physicalPath: null,
        size: null,
        title: null,
        type: null,
      },
      disabled: true,
      onboardGroupOptions: [],
      genders: [
        { text: 'Nam', value: 1 },
        { text: 'Nữ', value: 2 },
        { text: 'Khác', value: 0 },
      ],
      titles: [
        { text: 'Cô', value: 0 },
        { text: 'Chú', value: 1 },
        { text: 'Anh', value: 2 },
        { text: 'Chị', value: 3 },
        { text: 'Em', value: 4 },
      ],
      isDisabled: false,
    };
  },
  computed: {
    ...mapState(['coaches', 'courses', 'partners']),
    diseasesOpts() {
      return [
        { text: 'Tiền đái tháo đường', value: DISEASES.TIEN_DAI_THAO_DUONG },
        { text: 'Đái tháo đường típ 1', value: DISEASES.DAI_THAO_DUONG_TIP_1 },
        { text: 'Đái tháo đường típ 2', value: DISEASES.DAI_THAO_DUONG_TIP_2 },
        {
          text: 'Đái tháo đường thai kì',
          value: DISEASES.DAI_THAO_DUONG_THAI_KI,
        },
        { text: 'Tăng huyết áp', value: DISEASES.TANG_HUYET_AP },
        { text: 'Béo phì', value: DISEASES.BEO_PHI },
        { text: 'Khác', value: DISEASES.KHAC },
      ];
    },
  },
  watch: {
    targetItem: {
      deep: true,
      handler(val) {
        this.form = {
          id: val.id,
          name: val.name,
          title: val.title,
          phoneNumber: val.phoneNumber,
          gender: val.gender,
          birthYear: val.birthYear,
          status: val.status,
          coachId: val.coachId,
          reasonOut: val.reasonOut,
          diseaseType: val.diseaseType,
          courseId: val.courseId,
          contactSource: val.contactSource,
          packageId: val.packageId,
          yearOfIllness: val.yearOfIllness,
          purchaseDate: val.purchaseDate
            ? new Date(val.purchaseDate * 1000)
            : null,
          customerPartnerId: val.customerPartnerId,
          onboardGroup: val.onboardGroup
            ? { text: val.onboardGroup, value: val.onboardGroup }
            : null,
        };
        this.ensureOnboardGroupOption(val.onboardGroup);
        if (val.id) {
          this.getCustomerFile(val.id);
        }
      },
    },
  },
  methods: {
    previewSelectedFile(url) {
      window.open(url, '_blank');
    },
    removeSelectedFile(index) {
      if (
        !this.selectedFiles ||
        !Array.isArray(this.selectedFiles) ||
        index < 0 ||
        index >= this.selectedFiles.length
      ) {
        console.error('Invalid index or selectedFiles is empty:', {
          index,
          selectedFiles: this.selectedFiles,
        });
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Không thể xóa file do danh sách trống hoặc chỉ số không hợp lệ.',
        });
        return;
      }
      const removedFile = this.selectedFiles[index];
      if (!removedFile || !removedFile.file) {
        console.error('Invalid file object at index:', index, removedFile);
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Không thể xóa file do dữ liệu không hợp lệ.',
        });
        return;
      }
      this.selectedFiles.splice(index, 1);
      this.file = this.file.filter((f) => f !== removedFile.file);
    },
    getIconPath(filename) {
      const ext = filename.toLowerCase();

      switch (ext) {
        case '.doc':
        case '.docx':
          return '/media/svg/icons/Neolex/File/file-doc.svg';
        case '.pdf':
          return '/media/svg/icons/Neolex/File/file-pdf.svg';
        case '.jpg':
        case '.jpeg':
        case '.png':
          return '/media/svg/icons/Neolex/File/file-png.svg';
        case '.xlsx':
        case '.sheet':
          return '/media/svg/icons/Neolex/File/file-exel.svg';
        default:
          return '/media/svg/icons/Neolex/File/file-default.svg';
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    handleCancel() {
      this.disabled = true;
      this.uploadedFiles = [];
      this.selectedFiles = [];
      this.file = [];
      localStorage.removeItem('customerReceivesId');
      this.$bvModal.hide('customer-receive-detail-modal');
      this.pdfUrl = null;
    },
    async handelEdit() {
      await this.choosenCourse();
      this.disabled = false;
    },
    getNameOf(key, value) {
      switch (key) {
        case 'coach':
          return this.coaches?.find((item) => item.value == value) ?? null;
        case 'diseaseType':
          return this.diseasesOpts?.find((item) => item.value == value) ?? null;
        case 'course':
          return this.courses?.find((item) => item.value == value) ?? null;
        case 'gender':
          return this.genders?.find((item) => item.value == value) ?? null;
        case 'title':
          return this.titles?.find((item) => item.value == value) ?? null;
        case 'package':
          return this.packagesName?.find((item) => item.id == value) ?? null;
        case 'partner': {
          return this.partners?.find((item) => item.id == value) ?? null;
        }
      }
    },
    async selected(value, form, optionsArr) {
      const v = value
        ? optionsArr.find((el) => el.value === value?.value)
        : null;
      const pack = value ? optionsArr.find((el) => el.id === value?.id) : null;

      switch (form) {
        case 'coach':
          this.form.coachId = v?.value || null;
          break;
        case 'diseaseType':
          this.form.diseaseType = v?.value || null;
          break;
        case 'course':
          this.form.courseId = v?.value || null;
          break;
        case 'gender':
          this.form.gender = v?.value ?? null;
          break;
        case 'title':
          this.form.title = v?.value ?? null;
          break;
        case 'package':
          this.form.packageId = pack?.id || null;
          break;
        case 'customerPartner':
          this.form.customerPartnerId = v?.id || null;
          break;
      }
    },
    async handleSubmit() {
      this.isDisabled = true;
      console.log('Form data:', this.form);
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        console.log('Validation errors:', this.errors.items);
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Vui lòng kiểm tra lại các trường bắt buộc.',
        });
        this.isDisabled = false;
        return;
      }

      const namePattern = /^[\p{L}\s]+$/u;
      if (!namePattern.test(this.form.name)) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Tên chỉ được phép chứa chữ cái và khoảng trắng (bao gồm tiếng Việt có dấu).',
        });
        this.isDisabled = false;
        return;
      }

      const birthYearPattern = /^\d{4}$/;
      if (!birthYearPattern.test(this.form.birthYear)) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Năm sinh phải là 4 ký tự số.',
        });
        this.isDisabled = false;
        return;
      }

      const phoneNumberPattern = /^\+?\d+$/;
      if (!phoneNumberPattern.test(this.form.phoneNumber)) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Số điện thoại chỉ được phép chứa ký tự số.',
        });
        this.isDisabled = false;
        return;
      }

      // if (!this.form.customerPartnerId) {
      //   this.$toastr.e({
      //     title: 'Lỗi!',
      //     msg: 'Vui lòng chọn đối tác.',
      //   });
      //   this.isDisabled = false;
      //   return;
      // }

      try {
        let fileUrls = [];
        if (this.file && this.file.length > 0) {
          const formData = new FormData();
          formData.append('customerReceivesId', this.form.id);
          Array.from(this.file).forEach((file) => {
            formData.append('Files', file);
          });
          const fileResponse = await this.$api.post(
            '/CustomerReceivesFile',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            },
          );
          if (fileResponse && fileResponse.data) {
            fileUrls = fileResponse.data;
          }
        }

        const payload = {
          id: this.form.id,
          name: this.form.name,
          title: this.form.title?.value ?? this.form.title,
          phoneNumber: this.form.phoneNumber,
          gender: this.form.gender.value ? this.form.gender.value : this.form.gender,
          birthYear: this.form.birthYear,
          yearOfIllness: this.form.yearOfIllness,
          purchaseDate: this.form.purchaseDate
            ? Math.floor(this.form.purchaseDate.getTime() / 1000)
            : null,
          coachId: this.form.coachId,
          reasonout: this.form.reasonOut,
          diseaseType: this.form.diseaseType,
          courseId: this.form.courseId,
          contactSource: this.form.contactSource,
          packageId: this.form.packageId,
          customerPartnerId: this.form.customerPartnerId,
          status: this.form.status,
          onboardGroup: this.form.onboardGroup?.value ?? this.form.onboardGroup ?? null,
          fileUrls: fileUrls.length > 0 ? fileUrls : undefined,
        };

        await this.$api.put(
          `/CustomerReceives/update/${this.form.id}`,
          JSON.stringify(payload),
          {
            headers: { 'Content-Type': 'application/json' },
          },
        );

        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Cập nhật khách hàng thành công.',
        });
      } catch (error) {
        console.error('Submit Error:', error);
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error.message || 'Đã xảy ra lỗi khi cập nhật thông tin',
        });
      } finally {
        this.selectedFiles = [];
        this.$emit('load-data');
        this.$bvModal.hide('customer-receive-detail-modal');
        this.isDisabled = false;
        this.file = [];
        this.uploadedFiles = [];
        this.pdfUrl = null;
      }
    },
    async choosenCourse() {
      this.$store.commit('context/setLoading', true);
      try {
        const { data } = await this.$api.get(
          `Courses/CoachInCourse?courseId=${ONBOARDING.ID}`,
        );
        this.listCoaches = data?.map((c) => ({
          text: c?.fullName,
          value: c?.id,
        }));
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    handleFileUpload(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (files && files.length) {
        this.file = Array.from(files);
        this.selectedFiles = [];
        Array.from(files).forEach((file) => {
          const allowedTypes = [
            'application/pdf',
            'image/jpeg',
            'image/png',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          ];
          if (!allowedTypes.includes(file.type)) {
            this.$toastr.e({
              title: 'Lỗi!',
              msg: 'Chỉ hỗ trợ tệp PDF, JPG, PNG, DOCX, XLSX.',
            });
            return;
          }
          if (file.size > 5 * 1024 * 1024) {
            this.$toastr.e({
              title: 'Lỗi!',
              msg: 'Kích thước tệp không được vượt quá 5MB.',
            });
            return;
          }
          const previewUrl = [
            'image/jpeg',
            'image/png',
            'application/pdf',
          ].includes(file.type)
            ? URL.createObjectURL(file)
            : null;

          let fileType;
          switch (file.type) {
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
              fileType = '.xlsx';
              break;
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
              fileType = '.docx';
              break;
            case 'application/pdf':
              fileType = '.pdf';
              break;
            case 'image/jpeg':
              fileType = '.jpeg';
              break;
            case 'image/png':
              fileType = '.png';
              break;
            default:
              fileType = '.' + file.type.split('/').pop();
          }

          this.selectedFiles.push({
            title: file.name,
            type: fileType,
            previewUrl: previewUrl,
            file: file,
          });
        });
      }
    },
    async getCustomerFile(id) {
      const customerReceivesId = id;
      try {
        const response = await this.$api.get(
          `/CustomerReceivesFile?CustomerReceivesId=${customerReceivesId}`,
        );
        this.existingFiles = response.data.items;
      } catch (error) {
        console.error('Error in getCustomerFile:', error);
        this.$toastr.e({
          title: 'Lỗi tải file',
          msg: error.message || 'Không thể tải danh sách file',
        });
        this.existingFiles = [];
      }
    },
    async removeExistingFile(id) {
      this.$swal({
        title: '',
        text: `Bạn có chắc muốn xóa tệp này không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `Xóa`,
            value: true,
            visible: true,
            className: `btn btn-inactive`,
            closeModal: true,
          },
        },
      }).then(
        async function (result) {
          if (result) {
            try {
              await this.$api.delete(`CustomerReceivesFile/${id}`);
              this.$toastr.s({
                title: 'Thành công!',
                msg: 'Xóa tệp thành công.',
              });
              if (this.form.id) {
                await this.getCustomerFile(this.form.id);
              } else {
                console.error('Error: form.id is null');
                this.$toastr.e({
                  title: 'Lỗi!',
                  msg: 'Không thể load lại danh sách file vì ID khách hàng không hợp lệ.',
                });
              }
            } catch (error) {
              console.error('Error in removeExistingFile:', error);
              this.$toastr.e({
                title: 'Lỗi',
                msg: error.message || 'Không thể xóa tệp',
              });
            }
          }
        }.bind(this),
      );
    },
    viewFile(url) {
      try {
        if (!url || !url.startsWith('http')) {
          throw new Error('URL không hợp lệ');
        }
        window.open(url, '_blank');
      } catch (error) {
        console.error('Error in viewFile:', error);
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Không thể mở file: ' + error.message,
        });
      }
    },
    downloadFile(fileUrl, filename) {
      try {
        if (!fileUrl || !fileUrl.startsWith('http')) {
          throw new Error('URL không hợp lệ');
        }
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = filename || 'download';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Đang tải file...',
        });
      } catch (error) {
        console.error('Download Error:', error);
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Không thể tải file: ' + error.message,
        });
      }
    },
    // Đảm bảo nhóm hiện tại của khách luôn có trong options, kể cả khi list chưa load xong
    ensureOnboardGroupOption(group) {
      const name = (group || '').trim();
      if (!name) return;
      if (!this.onboardGroupOptions.some((o) => o.value === name)) {
        this.onboardGroupOptions.push({ text: name, value: name });
      }
    },
    addOnboardGroupTag(newTag) {
      const name = (newTag || '').trim();
      if (!name) return;
      let tag = this.onboardGroupOptions.find((o) => o.value === name);
      if (!tag) {
        tag = { text: name, value: name };
        this.onboardGroupOptions.push(tag);
      }
      this.form.onboardGroup = tag;
    },
    // Gom danh sách nhóm đã tồn tại từ toàn bộ khách hàng để làm options
    async loadOnboardGroups() {
      try {
        const size = 200;
        const first = await this.$api.get('CustomerReceives', {
          params: { page: 1, size },
        });
        const rows = [...(first.data || [])];
        const total = Number(first.meta?.total || rows.length);
        const totalPages = Math.ceil(total / size);

        if (totalPages > 1) {
          const requests = [];
          for (let page = 2; page <= totalPages; page++) {
            requests.push(
              this.$api.get('CustomerReceives', { params: { page, size } }),
            );
          }
          const restResponses = await Promise.all(requests);
          restResponses.forEach((res) => rows.push(...(res.data || [])));
        }

        const seen = new Set();
        const options = [];
        rows.forEach((el) => {
          const name = (el?.onboardGroup || '').trim();
          if (name && !seen.has(name)) {
            seen.add(name);
            options.push({ text: name, value: name });
          }
        });
        this.onboardGroupOptions = options;

        // Giữ lại nhóm của khách đang mở nếu nhóm đó không còn trong danh sách
        this.ensureOnboardGroupOption(this.form.onboardGroup?.value);
      } catch (error) {
        console.error('Load onboard groups error:', error);
      }
    },
  },
  async created() {
    this.loadOnboardGroups();
    if (this.targetItem.id) {
      await this.getCustomerFile(this.targetItem.id);
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.svg-icon.icon-disabled img {
  opacity: 0.5;
  transition: opacity 0.3s ease;
}
.svg-icon img {
  opacity: 1;
  transition: opacity 0.3s ease;
}
::v-deep .basic-select[name='partner'] .multiselect__content-wrapper {
  width: 400px !important;
  min-width: 400px !important;
  position: absolute !important;
  z-index: 1000 !important;
}

/* Dòng "tạo nhóm mới" là option duy nhất có data-select khác rỗng (tag-placeholder),
   các option thường đều có data-select="" vì select-label mặc định rỗng. */
::v-deep #onboardGroup-group
  .multiselect__option[data-select]:not([data-select=''])::before {
  content: '+ ';
  font-weight: 700;
}
</style>
